import { Capacitor, registerPlugin } from "@capacitor/core";

export const exportUpgradeProductId = "com.hakofit.export_unlimited";

type PurchaseOutcome = "purchased" | "cancelled" | "pending" | "unknown";

type ExportUpgradeResult = {
  productId: string;
  purchased: boolean;
  outcome?: PurchaseOutcome;
};

type HakofitPurchasesPlugin = {
  getStatus(options: { productId: string }): Promise<ExportUpgradeResult>;
  purchase(options: { productId: string }): Promise<ExportUpgradeResult>;
  restore(options: { productId: string }): Promise<ExportUpgradeResult>;
};

const HakofitPurchases = registerPlugin<HakofitPurchasesPlugin>("HakofitPurchases");

export function isNativeIosApp(): boolean {
  return Capacitor.getPlatform() === "ios" && Capacitor.isNativePlatform();
}

export async function getExportUpgradeStatus(): Promise<ExportUpgradeResult> {
  return HakofitPurchases.getStatus({ productId: exportUpgradeProductId });
}

export async function purchaseExportUpgrade(): Promise<ExportUpgradeResult> {
  return HakofitPurchases.purchase({ productId: exportUpgradeProductId });
}

export async function restoreExportUpgrade(): Promise<ExportUpgradeResult> {
  return HakofitPurchases.restore({ productId: exportUpgradeProductId });
}
